import type { FC, HTMLAttributes } from 'react';

import { HideDialogsConnected } from '@pp/core/src/components/hideDialogs/HideDialogsConnected';
import { FullScreenControlConnected } from '@pp/core/src/components/nav/navControls/fullScreenControl/FullScreenControlConnected';
import { HelpControlConnected } from '@pp/core/src/components/nav/navControls/helpControl/HelpControlConnected';
import { HistoryControlConnected } from '@pp/core/src/components/nav/navControls/historyControl/HistoryControlConnected';
import { LobbyControlConnected } from '@pp/core/src/components/nav/navControls/lobbyControl/LobbyControlConnected';
import { QuickGuideControlConnected } from '@pp/core/src/components/nav/navControls/quickGuideControl/QuickGuideControlConnected';
import { SettingsControlConnected } from '@pp/core/src/components/nav/navControls/settingsControl/SettingsControlConnected';
import { VolumeSliderControlConnected } from '@pp/core/src/components/nav/navControls/volumeSliderControl/VolumeSliderControlConnected';
import { NavDrawerControlConnected } from '@pp/core/src/components/nav/navDrawer/navDrawerControl/NavDrawerControlConnected';
import { RealityCheckConnected } from '@pp/core/src/components/popup/content/RealityCheckConnected';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';

import { CrashStreamControlConnected } from '../../components/navControls/streamControl';

import { ChatControlConnected } from './ChatControlConnected';
import { LiveSupportControlConnected } from './LiveSupportControlConnected';

import styles from './Nav.module.css';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { HIGHFLYER_PT } from '../../config';

export interface HeaderNavProps extends HTMLAttributes<HTMLDivElement> {}

export const CrashNavConnected: FC<HeaderNavProps> = () => {
  const isWide = useIsLargerThanWide();
  const tableVariant = useConfigSlice.getTableVariant();
  const isHighflyerPT = tableVariant === HIGHFLYER_PT;

  return (
    <>
      <div className={styles.nav}>
        <RealityCheckConnected />
        <div className={styles.nav__row}>
          <LobbyControlConnected />
          {isWide && <QuickGuideControlConnected />}
          <ChatControlConnected />
          <HistoryControlConnected />
          <HelpControlConnected />
          <LiveSupportControlConnected />
          <span className={styles.nav__rowVolumeControl}>
            <VolumeSliderControlConnected />
          </span>
          <SettingsControlConnected />
          {isHighflyerPT ? null : <CrashStreamControlConnected /> }
          <FullScreenControlConnected />
        </div>
      </div>
      <HideDialogsConnected>
        <NavDrawerControlConnected />
      </HideDialogsConnected>
    </>
  );
};
